import React from "react";
import { Box, Typography, Checkbox, FormControlLabel } from "@mui/material";

// B2C sales channels (ids match the backend CHANNELS_B2C config keys).
export const B2C_CHANNELS = [
  { id: "b2c_onlineStore", name: "Online Store" },
  { id: "google", name: "Google & YouTube" },
  { id: "facebook", name: "Facebook & Instagram" },
  { id: "pos", name: "Point of Sale" },
];

export const DEFAULT_B2C_PUBLICATIONS = B2C_CHANNELS.map((c) => c.id);

/**
 * B2C-only sales channel selector for bundles. Channels can only be selected
 * when the bundle status is ACTIVE (same rule as the product publishing).
 */
export default function BundlePublishing({ status, publications = [], onChange }) {
  const isActive = status === "ACTIVE";

  const toggle = (id) => {
    const exists = publications.includes(id);
    onChange(
      exists ? publications.filter((c) => c !== id) : [...publications, id]
    );
  };

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        Sales channels B2C
      </Typography>
      {!isActive && (
        <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
          Set the status to ACTIVE to publish on sales channels.
        </Typography>
      )}
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {B2C_CHANNELS.map((channel) => (
          <FormControlLabel
            key={channel.id}
            control={
              <Checkbox
                checked={isActive && publications.includes(channel.id)}
                disabled={!isActive}
                onChange={() => toggle(channel.id)}
              />
            }
            label={channel.name}
          />
        ))}
      </Box>
    </Box>
  );
}
